var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _rect3, _rect4, _path6, _path7, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 209,
    viewBox: "0 0 218 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 114,
    width: 145.13,
    height: 145.13,
    rx: 59.0645,
    transform: "rotate(45 114 0)",
    fill: "#D4E8F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.689 31.1829C147.064 27.5582 141.188 27.5582 137.563 31.1829C133.938 34.8076 133.938 40.6843 137.563 44.309C141.188 47.9337 147.064 47.9337 150.689 44.309C154.314 40.6843 154.314 34.8076 150.689 31.1829Z",
    fill: "#D4E8F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.16 40.3862C157.841 39.0681 155.704 39.0681 154.386 40.3862C153.068 41.7043 153.068 43.8413 154.386 45.1593C155.704 46.4774 157.841 46.4774 159.16 45.1593C160.478 43.8413 160.478 41.7043 159.16 40.3862Z",
    fill: "#D4E8F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2981 112.533C50.9123 111.601 51.4654 109.537 50.5334 107.923C49.6014 106.309 47.5372 105.755 45.9229 106.687C44.3086 107.619 43.7555 109.684 44.6876 111.298C45.6196 112.912 47.6838 113.465 49.2981 112.533Z",
    fill: "#D4E8F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7235 130.068C19.9343 129.369 20.3491 127.821 19.6501 126.61C18.9511 125.399 17.4029 124.985 16.1922 125.684C14.9815 126.383 14.5667 127.931 15.2657 129.141C15.9647 130.352 17.5128 130.767 18.7235 130.068Z",
    fill: "#D4E8F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.58 25.1931C136.921 24.5341 135.852 24.5341 135.193 25.1931C134.534 25.8521 134.534 26.9206 135.193 27.5797C135.852 28.2387 136.921 28.2387 137.58 27.5797C138.239 26.9206 138.239 25.8521 137.58 25.1931Z",
    fill: "#D4E8F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 117.46,
    width: 23.6258,
    height: 23.6258,
    rx: 4,
    transform: "rotate(-60 179 117.46)",
    fill: "#D4E8F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5181,
    y: 118.812,
    width: 23.6258,
    height: 23.6258,
    rx: 4,
    transform: "rotate(-30 18.5181 118.812)",
    fill: "#D4E8F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0005,
    y: 98,
    width: 9,
    height: 9,
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5005 63C65.5005 61.6193 66.6198 60.5 68.0005 60.5H160C161.381 60.5 162.5 61.6193 162.5 63V143C162.5 144.381 161.381 145.5 160 145.5H68.0005C66.6198 145.5 65.5005 144.381 65.5005 143V63Z",
    fill: "#FFC220",
    stroke: "#4D5659",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0005 63C64.0005 60.7909 65.7913 59 68.0005 59H160C162.21 59 164 60.7909 164 63V69H64.0005V63Z",
    fill: "#4D5659"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75.0005,
    y: 83,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#4D5659"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 89.0005,
    y: 85,
    width: 64,
    height: 4,
    rx: 2,
    fill: "#4D5659"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 75.0005,
    y: 103,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#4D5659"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 89.0005,
    y: 105,
    width: 64,
    height: 4,
    rx: 2,
    fill: "#4D5659"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 75.0005,
    y: 123,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#4D5659"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 89.0005,
    y: 125,
    width: 64,
    height: 4,
    rx: 2,
    fill: "#4D5659"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOrders);
export default __webpack_public_path__ + "static/media/empty_orders.4ca3ce16191773663dbb23fa95c057b4.svg";
export { ForwardRef as ReactComponent };